import React from 'react';
import styled from 'styled-components';
import { mobileMediaQuery, themeColor } from '../../Theming';
import bgImage from '../../Assets/TreePlanting/TreesBackgroundDesktop.png';

const Container = styled.div``;

const ImageContainer = styled.div`
  border-radius: 14px;
  width: 100%;
  height: 377px;
  overflow: hidden;
  position: relative;

  ${mobileMediaQuery} {
    height: 184px;
    border-radius: 7px;
  }
`;

const HeroImage = styled.div`
  background-image: url(${bgImage});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  z-index: -1;
  background-position: 0px -80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${mobileMediaQuery} {
    background-size: cover;
    background-position: 0px -8px;
  }
`;

const HeaderText = styled.p`
  font-weight: normal;
  font-size: 32px;
  text-align: center;
  color: ${themeColor('white')};
  z-index: 1;
  margin: 0;
  font-family: SuisseIntl-Medium;

  ${mobileMediaQuery} {
    font-size: 14px;
    font-family: SuisseIntl-Regular;
  }
`;

const HeaderTextBold = styled(HeaderText)`
  font-size: 46px;
  font-family: SuisseIntl-Medium;
  font-weight: normal;

  ${mobileMediaQuery} {
    font-size: 20px;
    font-family: SuisseIntl-Bold;
  }
`;

interface Props {
  headerText?: string;
  subText?: string;
}

const Hero: React.FC<Props> = ({ headerText, subText }) => {
  return (
    <Container>
      <ImageContainer>
        <HeroImage>
          <HeaderTextBold>{headerText}</HeaderTextBold>
          <HeaderText>{subText}</HeaderText>
        </HeroImage>
      </ImageContainer>
    </Container>
  );
};

export default Hero;
